import { cB, cM } from '../../../_utils/cssr'

// --n-gap
export default cB('input-otp', [
  cM('rtl', `
    direction: rtl;
  `)
])
